import styled from "styled-components";

export default function WhoCanApply() {
  return (
    <Section id="who-can-apply">
      <Container>

        <Left>
          <Title>Who can apply?</Title>

          <Points>
  <PointCard>
    The application may be submitted by a <b>company or its CSR foundation arm.</b>
  </PointCard>

  <PointCard>
    Eligible projects must be funded under <b>CSR initiatives or philanthropic grants.</b>
  </PointCard>
</Points>

        </Left>

      </Container>
    </Section>
  );
}

/* STYLES */

const Section = styled.section`
  scroll-margin-top: 100px;

  @media (max-width: 768px) {
    padding: 10px 4px;
    scroll-margin-top: 100px;
  }
`;

const Container = styled.div`
  max-width:1200px;
  margin:auto;
`;

const Left = styled.div`
  text-align:left;
`;

const Title = styled.h2`
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 4px;
  color: #791e1b;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 4px;
    text-align: center;
  }
`;

const Points = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 8px;
`;

const PointCard = styled.div`
  background: #f9f6ef;
  border-left: 4px solid #d6a54f;
  padding: 16px 18px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  box-shadow: 0 6px 20px rgba(0,0,0,0.05);
  transition: 0.25s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px;
  }
`;


